import React, { FC, useCallback, useMemo } from "react";
import dynamic from 'next/dynamic';

const WalletConnectModal = dynamic(() => import('./index'), { ssr: false });
const SolanaWalletModal = dynamic(() => import('./SolanaWalletModal'), { ssr: false });
const SuiWalletModal = dynamic(() => import('./SuiWalletModal'), { ssr: false });

// Re-export a simple provider that renders the modals.
// The actual modal state is managed by the MobX store (modal.isOpen, modal.showEvm, etc.)
// We use a thin wrapper to avoid SSR issues with MobX observer components.
const ConnectWalletModalProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<>
			{children}
			<WalletConnectModal />
			<SolanaWalletModal />
			<SuiWalletModal />
		</>
	);
};

export default ConnectWalletModalProvider;
